import styled from 'styled-components/macro';
import px2vw from '../../../utils/px2vw';

export const FinancialCrimesTitle = styled.p`
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => { 
        return props.theme.mobCommonTitleFontSize?props.theme.mobCommonTitleFontSize:px2vw(20)
    }};  
    letter-spacing: ${props => props.theme.subtitleLetterSpacing};
    font-weight: 700;
    line-height: ${px2vw(30)};
`;
export const FinCrimeCol = styled.div`
    display: flex;
    flex-direction: column;   
    background-color: #E32C5E;
    color: #FFFFFF; 
    /* padding-left:  ${props => props.theme.paddingLeft};
    padding-right: ${props => props.theme.paddingRight}; */
    padding-bottom: ${px2vw(96)};
    padding-top: ${px2vw(80)};
    @media only screen and (max-width: 425px) {
        padding-left: 5%;
        padding-right: 5%;
    }
`;

export const FinancialCrimeRow = styled.div`
    display: flex;
    flex-direction: row;  
    justify-content: space-between;
    @media only screen and (max-width: 425px) {
        flex-direction: column; 
        padding-left: 15%;
        padding-right: 15%;        
    } 
`;


export const FinancialCrimessubTitle = styled.p`
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => props.theme.pFontSize};
    line-height:  ${props => props.theme.pLineHeight};
    font-weight: 400;
    letter-spacing: 0px;
    @media only screen and (max-width: 425px) {        
        padding-bottom: 15%;        
        padding-top: 7%;        
    } 
`;
export const FinancialCrimesStattext = styled.p`
    height: ${px2vw(56)};
    width: ${px2vw(236)};
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => props.theme.pFontSize};
    line-height:  ${props => props.theme.pLineHeight};
    font-weight: 500;
    letter-spacing: ${props => props.theme.subtitleLetterSpacing};
    @media only screen and (max-width: 425px) {
        height: auto;
        width: auto;      
        text-align: center;
    }
`;
export const FinancialCrimesStatData = styled.p`
    height: ${px2vw(56)};
    width: ${px2vw(236)};
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => { 
        return props.theme.mobCommonTitleFontSize?props.theme.mobCommonTitleFontSize:px2vw(32)
    }};  
    font-weight: 700;
    line-height:  ${px2vw(36)};
    letter-spacing: 0px;
    @media only screen and (max-width: 425px) {
        line-height:  ${px2vw(100)};
        height:auto;
        width: auto;        
        text-align: center;
        font-size: ${px2vw(120)};
    }
`;